import {
  call,
  fork,
  select,
  put,
  takeLatest
} from 'redux-saga/effects';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps,
  buyFlowUrls
} from '../../../navigation/navigationHelpers';
import {
  LOAD_CONTENT
} from './addOn';
import {
  showGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

// WORKERS
export function* loadContentWorker(action) {
  try {
    yield put(showGlobalSpinner());

    const addDefaultOfferEndpoint = navigationRoutes[navigationSteps.myPlan.OFFERS].endpoints.addDefaultOfferToCart();
    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'},
      {state: 'plan'},
      {state: 'checkEligibility', param: action.addOnType},
      {state: 'offers', param: ''}
    ], {errorPage});

    if (!success) {
      return;
    }

    const data = {
      buyflowConsumerType: action.addOnType
    };

    yield call(loader.request, addDefaultOfferEndpoint, {data, useGlobalSpinner: false});
    window.location.replace(buyFlowUrls.CUSTOMIZE);

  } catch(e) {
    //console.log(e);
  }
}

export default function* addOnSagas() {
  yield [
    fork(loadContentWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/addOn/addOnSagas.js
 **/